import {datadogLogs} from '@datadog/browser-logs';

export default function initializeDatadog() {
  datadogLogs.init({
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    site: process.env.DATADOG_SITE,

    service: process.env.DATADOG_SERVICE,
    env: process.env.DATADOG_ENV,
    version: process.env.COMMIT_SHA,

    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    telemetrySampleRate: 100,

    trackSessionAcrossSubdomains: true,
    useSecureSessionCookie: true,
    useCrossSiteSessionCookie: true,
  });
}
